const LightThemeColors = [
  {
    name: "BLUE_THEME",
    palette: {
      primary: {
        main: "#1e55bf",
        light: "#ECF2FF",
        dark: "#4570EA",
        contrastText: "#ffffff",
      },
      secondary: {
        main: "#414b68",
        light: "#E8F7FF",
        dark: "#23afdb",
        contrastText: "#ffffff",
      },
      background: {
        default: "#f8f9fd",
      },
      delete: {
        main: "#f44336",
      },
      check: {
        main: "#459977",
      },
      cancel: {
        main: "#64748B",
        light: "#F1F5F9",
        dark: "#475569",
        contrastText: "#ffffff",
      },
      primaryBtn: {
        main: "#2ca675",
        hover: "#25865e",
        disabled: "#25865e",
      },
    },
  },
];

export { LightThemeColors };
